import styles from "./style.less";
import React from "react";
const classnames = require("classnames");
import * as Utils from "../../utils/utils";
import UserAgreement from "../UserAgreement";

export default class OtpLogin extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isAgreeCheck: false,
      isOpenAgreement: false,
    };
  }

  changeHandle = (key: string) => {
    if (key === "isAgreeCheck") {
      let { isAgreeCheck } = this.state;
      this.setState({
        isAgreeCheck: !isAgreeCheck,
      });
    } else if (key === "openAgreement") {
      this.setState({
        isOpenAgreement: true,
      });
    } else if (key === "closeAgreement") {
      this.setState({
        isOpenAgreement: false,
      });
    }
  };

  loginHandle = () => {
    let { isAgreeCheck } = this.state;

    if (!isAgreeCheck) {
      Utils.Toast("请勾选“阅读并同意平台服务协议”", 2);
      return false;
    }

    this.props.loginHandle();
  };

  blurHandle = () => {
    setTimeout(() => {
      if (/iPhone/i.test(navigator.userAgent)) {
        window.scrollTo(0, 0);
      }
    }, 100);
  };

  render() {
    const {
      closeComponent,
      sendCodeHandle,
      changeHandle,
      phoneNumber,
      numberCode,
      isSending,
      count,
      title,
      isClosBtn,
    } = this.props;
    const { isAgreeCheck, isOpenAgreement } = this.state;

    return (
      <div className={classnames(styles.otp_login)}>
        <header className={classnames(styles.header)}>
          <div className={classnames(styles.close)}>
            {isClosBtn && (
              <span
                onClick={closeComponent}
                data-bid="B0001"
                className={styles.img}
              ></span>
            )}
          </div>
          <div className={styles.title}>{title || "登录"}</div>
        </header>

        <section className={classnames(styles.main)}>
          <div className={classnames(styles.input_box)}>
            <input
              type="number"
              maxLength={11}
              pattern="[0-9]*"
              onChange={(e) => changeHandle("phoneNumber", e.target.value)}
              onBlur={() => this.blurHandle()}
              value={phoneNumber}
              placeholder="请输入注册手机号"
              className={classnames(styles.phoneNumber)}
            />
            {phoneNumber ? (
              <span
                className={styles.clean}
                onClick={() => changeHandle("phoneNumber", "")}
              ></span>
            ) : (
              <span className={styles.space}></span>
            )}
          </div>

          <div className={classnames(styles.input_box)}>
            <input
              type="number"
              maxLength={6}
              pattern="[0-9]*"
              className={classnames(styles.code)}
              value={numberCode}
              onChange={(e) => changeHandle("numberCode", e.target.value)}
              onBlur={() => this.blurHandle()}
              placeholder="请输入验证码"
            />
            {numberCode ? (
              <span
                className={styles.clean}
                onClick={() => changeHandle("numberCode", "")}
              ></span>
            ) : (
              <span className={styles.space}></span>
            )}
            {isSending ? (
              <span className={classnames(styles.countDown)}>
                {`${count} S后重新发送`}
              </span>
            ) : (
              <span
                className={classnames(styles.sendbtn)}
                onClick={sendCodeHandle.bind(this, phoneNumber)}
              >
                发送验证码
              </span>
            )}
          </div>

          <div className={styles.isAgree}>
            <span
              onClick={() => this.changeHandle("isAgreeCheck")}
              className={!isAgreeCheck ? styles.radio : styles.checked}
            ></span>
            <p
              className={styles.tips}
              onClick={() => this.changeHandle("isAgreeCheck")}
            >
              &ensp;阅读并同意
            </p>
            <span
              onClick={() => this.changeHandle("openAgreement")}
              className={styles.agreement}
            >
              《平台用户协议》
            </span>
          </div>
        </section>

        <footer className={styles.footer}>
          <span
            className={classnames(styles.loginbtn)}
            onClick={this.loginHandle}
            data-bid="B0002"
          >
            立即登录
          </span>
        </footer>

        <UserAgreement
          isOpenAgreement={isOpenAgreement}
          closeAgreementHandle={() => this.changeHandle("closeAgreement")}
        />
      </div>
    );
  }
}
